// 宮崎県産業クイズ - 10問1セット×10セット

import { quizData } from './quizData';

export const quizSets = [
  {
    id: 1,
    title: "セット1: 産業構造と霧島酒造",
    category: "産業基礎",
    questions: quizData.slice(0, 10)
  },
  {
    id: 2,
    title: "セット2: 霧島酒造の歴史と製品",
    category: "霧島酒造",
    questions: quizData.slice(10, 20)
  },
  {
    id: 3,
    title: "セット3: 霧島酒造と先端製造業",
    category: "製造業",
    questions: quizData.slice(20, 30)
  },
  {
    id: 4,
    title: "セット4: 先端製造業の世界",
    category: "先端製造業",
    questions: quizData.slice(30, 40)
  },
  {
    id: 5,
    title: "セット5: 商業と金融の中心地",
    category: "商業・金融",
    questions: quizData.slice(40, 50)
  },
  {
    id: 6,
    title: "セット6: 金融機関とインフラ",
    category: "金融・インフラ",
    questions: quizData.slice(50, 60)
  },
  {
    id: 7,
    title: "セット7: 港湾と航空ネットワーク",
    category: "物流・交通",
    questions: quizData.slice(60, 70)
  },
  {
    id: 8,
    title: "セット8: ソラシドエアと経済史",
    category: "交通・経済史",
    questions: quizData.slice(70, 80)
  },
  {
    id: 9,
    title: "セット9: 口蹄疫危機と教訓",
    category: "経済史",
    questions: quizData.slice(80, 90)
  },
  {
    id: 10,
    title: "セット10: 産業の未来と発展",
    category: "産業発展",
    questions: quizData.slice(90, 100)
  }
];

// 全クイズデータを1つの配列にまとめたもの（既存のコードとの互換性のため）
export const allQuizData = quizSets.flatMap(set => set.questions);
